import { Box, SxProps, Theme } from "@mui/material";
import React from "react";
import { COLORS } from "../../constants";

interface SectionCardProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const SectionCard: React.FC<SectionCardProps> = ({ children, sx }) => {
  const defaultStyle: SxProps<Theme> = {
    backgroundColor: COLORS.white,
    borderRadius: "8px",
    p: 2,
    border: `1px solid ${COLORS.border}`,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    boxShadow: "none",
  };

  return (
    <Box sx={{ ...defaultStyle, ...sx } as SxProps<Theme>}>{children}</Box>
  );
};

export default SectionCard;
